var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "employees-list" },
    [
      _c("m-table-settings", {
        attrs: {
          columns: _vm.tableData.columns,
          "disabled-columns": _vm.tableData.disabledColumns,
          "default-disabled-columns": _vm.tableData.defaultDisabledColumns,
          "with-categories": "",
        },
        on: { submit: _vm.submitTableSettings },
        model: {
          value: _vm.tableSettingsModal,
          callback: function ($$v) {
            _vm.tableSettingsModal = $$v
          },
          expression: "tableSettingsModal",
        },
      }),
      _c(
        "div",
        { staticClass: "employees-list__wrapper" },
        [
          _c("div", { staticClass: "employees-list__actions" }, [
            _c(
              "div",
              { staticClass: "employees-list__actions-item" },
              [
                _c("c-button", {
                  attrs: {
                    responsive: "",
                    disabled:
                      _vm.isLoadingTable ||
                      _vm.tableData.activeFilteredColumns.length === 0,
                    label: "Сбросить фильтры столбцов",
                    icon: { color: "pink", icon: "filter-drop" },
                    type: "with-icon",
                  },
                  on: { click: _vm.resetColumnFilters },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "employees-list__actions-item" },
              [
                _c("c-button", {
                  attrs: {
                    responsive: "",
                    label: "Настроить столбцы",
                    icon: "cog",
                    type: "with-icon",
                  },
                  on: {
                    click: function ($event) {
                      _vm.tableSettingsModal = true
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          !_vm.isLoadingTable
            ? _c(
                "div",
                { staticClass: "employees-list__table" },
                [
                  _c("c-data-table", {
                    ref: "table",
                    staticClass: "employees-list-table",
                    attrs: {
                      levels: _vm.isAllowedToWorkerSummaryData ? 3 : 2,
                      "sorted-column": _vm.tableData.sortedColumn,
                      "disabled-columns": _vm.tableData.disabledColumns,
                      "filtered-columns": _vm.tableData.filteredColumns,
                      "enabled-fields": _vm.enabledFields,
                      "active-filtered-columns":
                        _vm.tableData.activeFilteredColumns,
                      data: _vm.tableData,
                      "reference-list": _vm.referenceFilterList,
                      "empty-records-label": "Сотрудники не найдены",
                    },
                    on: {
                      sortedEvent: _vm.refreshTable,
                      getReferenceValues: _vm.setColumnReferenceFilterList,
                      "reset-column-filters": function ($event) {
                        _vm.tableData.activeFilteredColumns = []
                      },
                      "remove-column-filter": _vm.onColumnFilterRemove,
                      "set-column-filter": _vm.onSetColumnFilter,
                      "set-column-filter-by-index":
                        _vm.onSetColumnFilterByIndex,
                      "disable-column-sorted-flag":
                        _vm.onDisableColumnSortedFlag,
                      "change-sorting-column": _vm.onSortingColumnChange,
                      "edit-worker": function ($event) {
                        return _vm.$emit("edit-worker", $event)
                      },
                    },
                  }),
                  _vm.isLoadingData
                    ? _c("c-loader", {
                        attrs: {
                          label: "Загрузка данных",
                          active: _vm.isLoadingData,
                          height: "150",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c("ItemsCount", {
                        attrs: {
                          "shown-items-count": _vm.recordsCount,
                          "total-items-count": _vm.getTotalRecordsCount,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("top-button", { attrs: { root: ".layout" } }),
                ],
                1
              )
            : _vm._e(),
          _vm.isLoadingTable
            ? _c("c-loader", {
                attrs: {
                  label: "Загрузка списка сотрудников",
                  active: _vm.isLoadingTable,
                  height: "500",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }